import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SecurazeToolForm from './SecurazeToolForm';
import * as Yup from 'yup';
import * as actions from "./store/securazeToolsActions";
import History from '../../../History';
import { withStyles, CircularProgress, Dialog, Typography } from "@material-ui/core";
import { hasPermission } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: "auto",
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
            margin: 0,
            width: "100%"
        }
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    typographyTo: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
    },
    typography: {
        marginTop: "5px",
        color: theme.palette.buttonText.default,
        position: "absolute",
        top: "40%",
        right: "0",
        textAlign: "center",
        left: "0"
    },
    div: {
        marginBottom: "1px",
        position: "relative"
    },
    circularProgress: {
        marginBottom: "10px"
    }
});

const SecurazeToolCreate = props => {
    const { classes, activeCustomerID, onClearState, translations, permissions, onCreateSecurazeTool, securazeTool } = props;
    const [fileToSend, setFileToSend] = useState({ fileToSend: {}, fileName: '' });

    useEffect(() => {
        return () => {
            onClearState()
        };
    }, [onClearState]);

    const handleUpload = event => {
        let file = event[0];
        if (!file) {
            setFileToSend({ fileToSend: {}, fileName: '' });
            return;
        }
        setFileToSend({ fileToSend: file, fileName: file.name });
    };

    const handleSubmit = async dataForm => {
        const data = new FormData();
        data.append("File", fileToSend.fileToSend);
        data.append("FileName", fileToSend.fileName);
        data.append("ToolName", dataForm.ToolName);
        data.append("Status", dataForm.Status);
        data.append("ForAllCustomers", dataForm.ForAllCustomers);
        data.append("ActiveCustomerID", activeCustomerID);
        let token = localStorage.getItem("SESSION");

        data.append("Token", token);
        let result = await onCreateSecurazeTool(data);
        if (result) {
            History.goBack();
        }
    }

    let initialValues = {
        ToolName: '',
        Status: 'test',
        ForAllCustomers: false,
    };

    let formSettings = {
        Validation: {
            ToolName: Yup.string().required("Required"),
            Status: Yup.string().required("Required"),
            ForAllCustomers: Yup.bool().required("Required"),
        },
        FormTitle: translations["create_new_securaze_tool"] || "Create new securaze tool",
        ButtonSubmit: hasPermission(permissions, 'securaze_tool_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
    };

    return (
        <div>
            <SecurazeToolForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                handleUpload={handleUpload}
                fileName={fileToSend.fileName}
                translations={translations}
            />
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={false}
                open={securazeTool.snackStart}
                PaperProps={{
                    classes: {
                        root: classes.paper
                    }
                }}
            >
                <div className={classes.div}>
                    <CircularProgress
                        variant="static"
                        color="primary"
                        className={classes.circularProgress}
                        size={300}
                        value={securazeTool.progress ? securazeTool.progress > 100 ? 100 : securazeTool.progress : 0}
                    />
                    <Typography
                        className={classes.typography}
                        variant="h4"
                    >
                        {securazeTool.progress ? securazeTool.progress > 100 ? 100 : securazeTool.progress : 0}%
                    </Typography>
                    <br></br>
                </div>
                <Typography
                    variant="h5"
                    className={classes.typographyTo}
                >
                    {translations['do_not_refresh'] || 'Please do not refresh THIS page. Uploading'}&nbsp;{securazeTool.loadSize ? securazeTool.loadSize : 0} / {securazeTool.maxSize ? securazeTool.maxSize : 0}MB
                </Typography>
            </Dialog>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        securazeTool: state.exportImport.securazeTools,
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onClearState: () => dispatch(actions.ClearStateCreate()),
        onCreateSecurazeTool: data => dispatch(actions.createNewSecurazeTool(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(SecurazeToolCreate));